// Sections NAF (niveau le plus large) pour le filtre par secteur d'activité.
export const NAF_SECTIONS = [
  { code: "A", label: "Agriculture, sylviculture et pêche" },
  { code: "B", label: "Industries extractives" },
  { code: "C", label: "Industrie manufacturière" },
  { code: "D", label: "Électricité, gaz, vapeur et air conditionné" },
  { code: "E", label: "Eau, assainissement, déchets et dépollution" },
  { code: "F", label: "Construction" },
  { code: "G", label: "Commerce ; réparation d'automobiles" },
  { code: "H", label: "Transports et entreposage" },
  { code: "I", label: "Hébergement et restauration" },
  { code: "J", label: "Information et communication" },
  { code: "K", label: "Activités financières et d'assurance" },
  { code: "L", label: "Activités immobilières" },
  { code: "M", label: "Activités spécialisées, scientifiques et techniques" },
  { code: "N", label: "Services administratifs et de soutien" },
  { code: "O", label: "Administration publique" },
  { code: "P", label: "Enseignement" },
  { code: "Q", label: "Santé humaine et action sociale" },
  { code: "R", label: "Arts, spectacles et activités récréatives" },
  { code: "S", label: "Autres activités de services" },
  { code: "T", label: "Activités des ménages en tant qu'employeurs" },
  { code: "U", label: "Activités extra-territoriales" },
];
